import React from 'react';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { primitive } from 'styles/constants/primitives';

import { ContentBlock, FullLineSeparator } from '../../styled';

import { StyledScanAndPay } from './styled';

export const ScanScanAndPay = () => {
  const scanAndPayEnabled = useFlag(LaunchDarklyFlag.ENABLE_TH_SCAN_AND_PAY);
  if (!scanAndPayEnabled) {
    return null;
  }

  return (
    <>
      <FullLineSeparator margin={`0 -${primitive.$spacing5}`} />
      <ContentBlock margin={`${primitive.$spacing5} 0`}>
        <StyledScanAndPay />
      </ContentBlock>
    </>
  );
};

export default ScanScanAndPay;
